import { render, staticRenderFns } from "./youtube-video.vue?vue&type=template&id=690313c7&"
import script from "./youtube-video.vue?vue&type=script&lang=js&"
export * from "./youtube-video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('690313c7')) {
      api.createRecord('690313c7', component.options)
    } else {
      api.reload('690313c7', component.options)
    }
    module.hot.accept("./youtube-video.vue?vue&type=template&id=690313c7&", function () {
      api.rerender('690313c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26pe8GTqxa6Ls/JS/youtube-video.vue"
export default component.exports